import { createUseFetch } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
function computeNdmId(config) {
    const { scenario, workspace, program, mode, panelName } = config;
    return `${scenario}_${workspace}_${program}_${mode}_${panelName}`;
}
export function computeNdmUrl(config) {
    let { scenario, workspace, program, mode, panelName } = config;
    if (mode === undefined)
        mode = "default";
    if (panelName.indexOf("_") !== -1) {
        panelName = panelName.substring(0, panelName.indexOf("_"));
    }
    return `/api/v1/ndm/${scenario}/${workspace}/${program}/${mode}/${panelName}`;
}
export const ndm = createItemFetcher(computeNdmUrl, "NDM_GET", computeNdmId);
export const createNdm = () => ndm;
export const useNdmFetcher = createUseFetch(ndm, (state) => state.ndm);
//# sourceMappingURL=index.js.map